<template>
  <config-pro-plus-base
    :plan-details-label="$t('billing.delta.cur_plan_detail')"
    :show-full-comparison-dialog="showPlanDetailDialog"
    show-plan-details>
    <template #config>
      <delta-edit-main :plan-type="planType" :max-to-add="maxToAdd" :sub-title="subTitle" :unit="unit" />
    </template>
  </config-pro-plus-base>
</template>

<script>
import ConfigProPlusBase from "@/plans/ZONE_PRO_PLUS/component/config-base";
import ConfigMixin from "@/plans/ZONE_PRO_PLUS/mixin/config-mixin";
import DeltaEditMain from "@/components/delta-edit-main.vue";
import { planTypes, ZOOM_ONE_PRO_PLUS_MAX_LICENSE } from "@/common/constants";
import { mapGetters } from "vuex";
import { ServiceConfirm } from "@/components/common/service-dialog/confirm";
import ViewCurrentDialog from "@/components/view-current-dialog/index.vue";

export default {
  mixins: [ConfigMixin],
  components: { DeltaEditMain, ConfigProPlusBase },
  data() {
    return {
      viewCurrentDialog: null,
    };
  },
  created() {
    this.viewCurrentDialog = new ServiceConfirm(ViewCurrentDialog);
  },
  computed: {
    ...mapGetters(["boughtPlans"]),
    planType() {
      return planTypes.ZONE_PRO_PLUS;
    },
    maxToAdd() {
      const boughtProp = this.boughtPlans.find(p => p.type === planTypes.ZONE_PRO_PLUS);
      const boughtLicense = boughtProp?.cartInfo?.selected_number;
      const max = boughtLicense > ZOOM_ONE_PRO_PLUS_MAX_LICENSE ? boughtLicense : ZOOM_ONE_PRO_PLUS_MAX_LICENSE;
      return max - boughtLicense;
    },
    subTitle() {
      return this.$t("billing.delta.buy_more_licenses_with_plan_name",
        { planName: this.$t("billing.zone_pro_plus.brief_title") + " " + this.$t("billing.pbx.regions.US") });
    },
    unit() {
      return this.$t("billing.zone_pro_plus.brief_title") + " " + this.$t("billing.planform.unit.license");
    },
  },
  methods: {
    showPlanDetailDialog() {
      this.viewCurrentDialog.confirm({
        planType: this.planType,
      }).catch((e) => {
        console.error(e);
      });
    },
  },
};
</script>
